import React, { memo } from 'react';
import TypewriterText from './TypewriterText';
import StaggerText from './StaggerText';

const TextEffect = memo(({ 
  effect = 'stagger', // 'stagger' or 'typewriter'
  children,
  ...props 
}) => {
  switch (effect) {
    case 'typewriter':
      return (
        <TypewriterText {...props}>
          {children}
        </TypewriterText>
      );
    
    case 'stagger':
    default:
      return (
        <StaggerText {...props}>
          {children}
        </StaggerText>
      );
  }
});

TextEffect.displayName = 'TextEffect';

export default TextEffect;

